import { useState, useRef, useEffect } from "react";
import "./TimePicker.css";
import { FieldHookConfig, useField, useFormikContext } from "formik";

interface TimePickerProps {
  labelName?: string;
  required?: boolean;
  onValueChange?: (value: string) => void;
}

const TimePicker = ({ labelName, required, onValueChange , ...props} : TimePickerProps  & FieldHookConfig<string>) => {

  const { setFieldValue } = useFormikContext();
  const [valueInput, setValueInput] = useState("");

  useEffect(() => {
    setValueInput(props.value)
  }, [props.value])

  useEffect(() => {
    valueInput ? setFieldValue(props.name, valueInput) : setFieldValue(props.name, '')
  }, [valueInput, props.name, setFieldValue])

  const [field, meta] = useField(props)

  const [time, setTime] = useState("0:00");
  const [showPopup, setShowPopup] = useState(false);
  const timePickerRef = useRef(null);

  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);
  const [isAm, setIsAm] = useState<boolean>(true);

  useEffect(() => {
    if (props.value) {
      setHour(parseInt(props.value.split(':')[0]));
      setMinute(parseInt(props.value.split(':')[1]));
    }
  }, [props.value]);

  const handleChange = (hour: number, minute: number) => {
    const formattedTime = `${hour}:${minute.toString().padStart(2, "0")}`
    setValueInput(formattedTime)
    onValueChange?.(formattedTime); 
    setTime(formattedTime);
  };


  useEffect(() => {
    handleChange(hour, minute);
    // eslint-disable-next-line
  }, [hour, minute]);


  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (timePickerRef.current && !((timePickerRef.current as HTMLElement).contains(event.target as Node))) {
      setShowPopup(false);
    }
  };

  const handleHourChange = (number: number , type: string) => {
    if ( type === 'add') {
      if (number < 23) {
        setHour(hour + 1);
      } else {
        setHour(0);
      } 
    } else {
      if (number > 0) {
        setHour(hour - 1);
      } else {
        setHour(23);
      }
    }
  }

  useEffect(() => {
    if (hour >= 12) {
      setIsAm(false);
    } else {
      setIsAm(true);
    }
  }, [hour])

  const handleMinuteChange = (number: number , type: string) => {
    if ( type === 'add') {
      if (number < 59) {
        setMinute(minute + 1);
      } else {
        setMinute(0);
      } 
    } else {
      if (number > 0) {
        setMinute(minute - 1);
      } else {
        setMinute(59);
      }
    }
  }

  const handleAmChange = () => {
    setIsAm(!isAm);
    if (!isAm) {
      setHour(hour - 12);
    } else {
      setHour(hour + 12);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="time-picker-container row mb-6" ref={timePickerRef}>
      <label htmlFor={props.name} className='col-lg-4 col-form-label fw-bold fs-6'>
        <span className={required ? 'required' : ''}>{labelName}</span>
      </label>
      <div className="col-lg-8">
        <div className="input-group col-lg-8" onClick={togglePopup}>
          <input
            {...field}
            name={props.name}
            id={props.name} 
            type="text" 
            className="form-control" 
            value={time} 
            readOnly 
          />
          <span className="input-group-text">
            <i className="bi bi-clock"></i>
          </span>
        </div>
      </div>
      {meta.touched && meta.error && (
        <p className="text-danger m-0 fw-semibold">{meta.error}</p>
      )}
      {showPopup && (
        <div className="row">
          <div className="col-lg-4 bg-danger"></div>
          <div className="col-lg-6 position-relative">
            <div className="time-picker-popup">
              <div className="input-time">
                {/* <p className="fw-bold fs-5 w-40px">{isAm ? hour.toString().padStart(2, "0") : (hour - 12).toString().padStart(2, "0")}</p> */}
                  <input
                    type="number"
                    min="0"
                    max="12"
                    className="fw-bold fs-5 border-0"
                    value={isAm ? hour.toString().padStart(2, "0") : (hour - 12).toString().padStart(2, "0")}
                    onChange={(e) => {
                      if (Number(e.target.value) > 11) {
                        setHour(11)
                      } else {
                        setHour(parseInt(e.target.value))
                      }
                    }}
                  />
                <div className="d-flex flex-column gap-0">
                  <i className="bi bi-caret-up-fill btn-set-time" onClick={() => handleHourChange(hour, 'add')}></i>
                  <i className="bi bi-caret-down-fill btn-set-time" onClick={() => handleHourChange(hour, 'minus')}></i>
                </div>
                <p className="fw-bold fs-5">:</p>
                {/* <p className="fw-bold fs-5 w-40px">{minute.toString().padStart(2, "0")}</p> */}
                <input
                    type="number"
                    min="0"
                    max="59"
                    className="fw-bold fs-5 border-0"
                    value={minute.toString().padStart(2, "0")}
                    onChange={(e) => {
                      if (Number(e.target.value) > 59) {
                        setMinute(59)
                      } else {
                        setMinute(parseInt(e.target.value))
                      }
                    }}
                  />
                <div className="d-flex flex-column gap-0">
                  <i className="bi bi-caret-up-fill btn-set-time" onClick={() => handleMinuteChange(minute, 'add')}></i>
                  <i className="bi bi-caret-down-fill btn-set-time" onClick={() => handleMinuteChange(minute, 'minus')}></i>
                </div>
                <p className="fw-bold fs-5 cursor-pointer mt-3px" onClick={ handleAmChange }>{isAm ? 'AM' : 'PM'}</p>
                
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimePicker;